import { Box, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
});
export const Toolbar = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: 8,
  gap: 8,
});
export const Content = styled(Box)({
  flex: "1 1 auto",
  overflow: "auto",
  padding: 12,
});
export const Loading = styled(Box)({
  display: "flex",
  justifyContent: "center",
  padding: 16,
});
export const TableScroll = styled(TableContainer)({ flex: "1 1 auto", overflow: "auto" });
export const HeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));
export const Row = styled(TableRow)({ cursor: "pointer" });
export const Text = styled(Typography)({ whiteSpace: "pre-wrap", overflowWrap: "anywhere" });
export const Utterance = styled(Box)({ marginBottom: 12 });
export const Heading = styled(Typography)({ marginTop: 12, marginBottom: 8 });
